// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"519":"080e7dd8","674":"a13cd00f"}[chunkId] + ".chunk.js";
};